import { render, staticRenderFns } from "./StripePaymentElement.vue?vue&type=template&id=3bf377eb&"
import script from "./StripePaymentElement.vue?vue&type=script&lang=js&"
export * from "./StripePaymentElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports